import {TheRave} from "../TheRave";
import {TheRaveLayers, Layers} from "./TheRaveLayers";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TheRaveReelView} from "../reels/TheRaveReelView";
import {ResizeHelper} from "../debug/utils/ResizeHelper";

export class TheRaveBackground extends PIXI.Container {

    private _logo: PIXI.Sprite;
    private _backgroundAnimation: any;
    private _reelBackgroundMain: PIXI.Sprite;

    constructor() {
        super();
        this.init();
    }

    private init() {
        this._backgroundAnimation = {
            "NORMAL": this.addNormalBGAnimation(),
            "FREESPIN": this.addFSBGAnimation(),
            "FREESPIN_SUPER": this.addSuperFSBGAnimation()
        };

        const reelBlackBG: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        reelBlackBG.tint = 0x000000;
        reelBlackBG.width = TheRaveReelView.SYMBOL_WIDTH * 5;
        reelBlackBG.height = TheRaveReelView.SYMBOL_HEIGHT * 3;
        reelBlackBG.position.set(360, TheRaveReelView.REEL_TOP);
        reelBlackBG.anchor.set(0.5, 0);
        TheRaveLayers.getLayer(Layers.REEL_BACKGROUND)!.addChild(reelBlackBG);

        this._reelBackgroundMain = new PIXI.Sprite(TheRave.assetLoader.getTextures("reelDividers/div")[0]);
        this._reelBackgroundMain.position.set(360, TheRaveReelView.REEL_TOP - 19);
        this._reelBackgroundMain.anchor.set(0.5, 0);
        TheRaveLayers.getLayer(Layers.REEL_FRAME)!.addChild(this._reelBackgroundMain);

        this._logo = new PIXI.Sprite(TheRave.assetLoader.getTextures("logo/logo_landscape")[0]);
        this._logo.position.set(-131, 58);
        this._logo.anchor.set(0.5, 0.5);
        this.addChild(this._logo);
        TheRaveLayers.getLayer(Layers.BACKGROUND)!.addChild(this);
        this.onOrientationChanged();
    }

    private addNormalBGAnimation(): PIXI.Container {
        const normalBgContainer: PIXI.Container = new PIXI.Container();
        normalBgContainer.name = "normalBgContainer";
        const layer4: PIXI.spine.Spine = this.createSpinEffect("bgMAINBlendTop", 360, 360);
        const layer3: PIXI.spine.Spine = this.createSpinEffect("bgMAINNormal", 360, 360);
        const layer2: PIXI.spine.Spine = this.createSpinEffect("bgMAINBlend", 360, 360);
        const layer1: PIXI.Sprite = new PIXI.Sprite(TheRave.assetLoader.getTextures("minBackground")[0]);

        layer1.anchor.set(0.5, 0.5);
        layer1.position.set(360, 360);

        normalBgContainer.addChild(layer1);
        normalBgContainer.addChild(layer2);
        normalBgContainer.addChild(layer3);
        normalBgContainer.addChild(layer4);
        return normalBgContainer;
    }

    private addFSBGAnimation(): PIXI.Container {
        const fsBgContainer: PIXI.Container = new PIXI.Container();
        fsBgContainer.name = "fsBgContainer";
        const layer4: PIXI.spine.Spine = this.createSpinEffect("bgFSBlendTop", 360, 360);
        const layer3: PIXI.spine.Spine = this.createSpinEffect("bgFSNormal", 360, 360);
        const layer2: PIXI.spine.Spine = this.createSpinEffect("bgFSBlend", 360, 360);
        const layer1: PIXI.Sprite = new PIXI.Sprite(TheRave.assetLoader.getTextures("minBackground")[0]);

        layer1.tint = 0x002CFFFF;
        layer1.anchor.set(0.5, 0.5);
        layer1.position.set(360, 360);
        fsBgContainer.addChild(layer1);
        fsBgContainer.addChild(layer2);
        fsBgContainer.addChild(layer3);
        fsBgContainer.addChild(layer4);
        return fsBgContainer;
    }

    private addSuperFSBGAnimation(): PIXI.Container {
        const superFSBgContainer: PIXI.Container = new PIXI.Container();
        superFSBgContainer.name = "superFSBgContainer";
        const layer4: PIXI.spine.Spine = this.createSpinEffect("bgSFSBlendTop", 360, 360);
        const layer3: PIXI.spine.Spine = this.createSpinEffect("bgSFSNormal", 360, 360);
        const layer2: PIXI.spine.Spine = this.createSpinEffect("bgSFSBlend", 360, 360);
        const layer1: PIXI.Sprite = new PIXI.Sprite(TheRave.assetLoader.getTextures("minBackground")[0]);

        layer1.tint = 0x002CFFFF;
        layer1.anchor.set(0.5, 0.5);
        layer1.position.set(360, 360);
        superFSBgContainer.addChild(layer1);
        superFSBgContainer.addChild(layer2);
        superFSBgContainer.addChild(layer3);
        superFSBgContainer.addChild(layer4);
        return superFSBgContainer;
    }

    private setBGContainerVisibility(mode: string): void {
        for (let key in this._backgroundAnimation) {
            const value: PIXI.Container = this._backgroundAnimation[key];
            if (key === mode) {
                this.addChild(value);
                value.visible = true;
                TheRave.stickySymbol.show(mode);
            } else {
                if (value.visible) {
                    this.removeChild(value);
                }
                value.visible = false;
            }
        }
    }

    private createSpinEffect(name: string, x: number, y: number): PIXI.spine.Spine {
        const effect: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(name));
        effect.name = name;
        effect.position.set(x, y);
        effect.visible = true;
        effect.autoUpdate = true;
        effect.state.setAnimation(0, "animation", true);
        return effect;
    }

    public onOrientationChanged() {
        this.setLogoPosition();
        //this._dimmer.width = NolimitApplication.screenBounds.width;
        //this._dimmer.height = NolimitApplication.screenBounds.height;
    }

    public onResize() {
        this.setLogoPosition();
        //this._dimmer.width = NolimitApplication.screenBounds.width;
        //this._dimmer.height = NolimitApplication.screenBounds.height;
    }

    private setLogoPosition():void{
        const isLandscape: boolean = NolimitApplication.isLandscape,
            widthMax:number = isLandscape? 1250:1280,
            heightMax:number= isLandscape? 1280:965;
        this._logo.visible = (NolimitApplication.screenBounds.width >= widthMax || NolimitApplication.screenBounds.height >= heightMax);
        this._logo.position.set(isLandscape ? -131 : 360, isLandscape ? 58 : (ResizeHelper.isIPadd?-50:-100));
    }

    public updateEnvironment(mode: string): void {
        this.setBGContainerVisibility(mode);
        //this.addChild(this._dimmer);
        this.addChild(this._logo);
    }

    public playShakeEffect(): void {
      // const originPos: PIXI.Point =  MathHelper.pointAdd(this._reelBackgroundMain.position,0);
      // AnimationEffects.Shake({
      //     x: 1.5,
      //     y: 1.5,
      //     obj: this._reelBackgroundMain,
      //     hertz: 80,
      //     duration:0.5,
      //     Intensity: 2,
      //     updateOnComplete: true,
      //     ease: Power2.easeOut,
      //     positionCb:() => originPos
      // }).play();
    }
}